import React, { useEffect, useRef } from "react";

function MapComponent({ location, setLong, setLat }) {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapId = useRef(`map_${Date.now()}`);

  useEffect(() => {
    let isMounted = true;
    const scriptId = "mappls-sdk-script";

    let current = [23.0225, 72.5714];

    if (location) {
      const parts = location.split(",").map((x) => Number(x.trim()));

      if (
        parts.length === 2 &&
        !isNaN(parts[0]) &&
        !isNaN(parts[1])
      ) {
        current = parts;
      }
    }

    setLat(current[0]);
    setLong(current[1]);

    const loadMap = () => {
      if (!isMounted) return;
      if (!window.mappls?.Map) return;

      const mapDiv = document.getElementById(mapId.current);
      if (!mapDiv) return;

      mapDiv.innerHTML = "";

      const map = new window.mappls.Map(mapId.current, {
        center: {
          lat: current[0],
          lng: current[1],
        },
        zoom: 7,
        zoomControl: true,
      });

      mapRef.current = map;

      markerRef.current = new window.mappls.Marker({
        map,
        position: {
          lat: current[0],
          lng: current[1],
        },
      });
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://apis.mappls.com/advancedmaps/api/4b5d031b33d1a6ecb0ddbc322dc81ab4/map_sdk?layer=vector&v=3.0";
      script.async = true;
      script.defer = true;
      script.onload = loadMap;
      document.body.appendChild(script);
    } else {
      if (window.mappls?.Map) {
        loadMap();
      } else {
        document.getElementById(scriptId).onload = loadMap;
      }
    }

    return () => {
      isMounted = false;
      markerRef.current = null;
      mapRef.current = null;

      const mapDiv = document.getElementById(mapId.current);
      if (mapDiv) {
        mapDiv.innerHTML = "";
      }
    };
  }, [location, setLat, setLong]);

  return (
    <div
      id={mapId.current}
      style={{
        width: "100%",
        height: "250px",
      }}
    />
  );
}

export default MapComponent;

// import { mappls } from "mappls-web-maps";
// import { useEffect } from "react";

// function MapComponent({ location, setLong, setLat }) {
//   useEffect(() => {
//     try {
//       if (location) {
//         var current;
//         var currentLocationString;

//         try {
//           currentLocationString = location.trim().split(",");
//         }
//         catch {
//           current = [23.0225, 72.5714];
//         }

//         if (currentLocationString.length < 2) {
//           current = [23.0225, 72.5714];
//         }
//         else if (isNaN(currentLocationString[0]) || isNaN(currentLocationString[1])) {
//           current = [23.0225, 72.5714];
//         }
//         else {
//           current = currentLocationString.map(Number);
//         }

//         // Map Properties
//         const mapProps = {
//           center: current,
//           zoomControl: true,
//           zoom: 7,
//         };

//         // New Map Variable
//         var mapplsClassObject = new mappls();
//         // Map marker
//         var marker;
//         setLat(current[0]);
//         setLong(current[1]);

//         // Checking if the object exists
//         if (mapplsClassObject) {
//           // Inintializing with API key
//           mapplsClassObject.initialize(
//             "4b5d031b33d1a6ecb0ddbc322dc81ab4",
//             () => {
//               const map = mapplsClassObject.Map({
//                 id: "map_",
//                 properties: mapProps,
//               });

//               if (map) {
//                 marker = mapplsClassObject.Marker({
//                   map: map,
//                   position: current,
//                 });
//               }
//             }
//           );
//         }
//       }
//     } catch (e) {
//       console.log("Something bad happened while loading map: " + e);
//     }
//   }, [location]);
  
//   return <div></div>;
// }

// export default MapComponent;